import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChrome, faFirefox, faOpera, faLinux, faAndroid, faApple, faSafari, faWindows } from '@fortawesome/free-brands-svg-icons';
import { BrowserContainer, IPContainer, IPText } from "./Components"
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { UAParser } from "ua-parser-js";
export const Browser = ({row}) => {
    const {t} = useTranslation();
    const parser = new UAParser(row.device);
    const result = parser.getResult();
    const [isTvOs, setIsTvOs] = useState(false)
    const Device = () => {
        if(result.ua.startsWith('tv/')){
            setIsTvOs(true)
            const dd = result.ua.split(" ");
            return `${result.os?.name} TV (${dd[0].replaceAll("tv/", "")})`;
        }
        if(result.device?.type && result.device?.type.toLowerCase().trim() === "smarttv"){
            return "Smart TV";
        }
        if(result.device?.type && result.device?.type.toLowerCase().trim() === "mobile"){
            return "Mobile";
        }
        return "Desktop";
        
    }
    const OSIcon = () => {
        if(!result.os || isTvOs) return null;
        switch(result.os?.name.toUpperCase()){
            case "LINUX":
                return <FontAwesomeIcon icon={faLinux} />
            case "WINDOWS":
                return <FontAwesomeIcon icon={faWindows} />
            case "ANDROID":
                return <FontAwesomeIcon icon={faAndroid} />
            case "IPHONE":
                return <FontAwesomeIcon icon={faApple} />
            case "APPLE":
                return <FontAwesomeIcon icon={faApple} />
            case "MACOS":
                return <FontAwesomeIcon icon={faApple} />
        }
        return null;
    }
    const BrowserIcon = () => {
        if(!result.browser.name || isTvOs) return result.browser.name;
        switch(result.browser.name.toUpperCase()){
            case "CHROME":
                return <FontAwesomeIcon icon={faChrome} />
            case "MOBILE CHROME":
                return <FontAwesomeIcon icon={faChrome} />
            case "FIREFOX":
                return <FontAwesomeIcon icon={faFirefox} />
            case "OPERA":
                return <FontAwesomeIcon icon={faOpera} />
            case "SAFARI":
                return <FontAwesomeIcon icon={faSafari} />
        }
        return null;
    }
    return (
        <BrowserContainer>
            <Device /> {!isTvOs && (<><OSIcon /> <BrowserIcon /></>)}
        </BrowserContainer>
    )
}